const Constants = {
    idToken: 'id_token'
}

export default Constants;